import { render, staticRenderFns } from "./LoginCommon.vue?vue&type=template&id=b5b3bce4"
import script from "./LoginCommon.vue?vue&type=script&lang=js"
export * from "./LoginCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports